import { SentryRoute as Route } from '@occc-app/App/sentry';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

import { routeCreator } from './stored-value.utils';
import { StoredValueGuard } from './stored-value.guard';
import StoredValueCreatePage from './stored-value-create-page';
import StoredValueUpdatePage from './stored-value-update-page';
import StoredValueUpdateByOfferPage from './stored-value-update-by-offer-page';
import StoredValueDetailsPage from './stored-value-details-page';
import StoredValueListPage from './stored-value-list-page';

const fallback = <UnauthorizedPage />;

export const storedValueRoutes = (
  <>
    <Route
      path={`${routeCreator.create}/*`}
      element={
        <StoredValueGuard fallback={fallback}>
          <StoredValueCreatePage />
        </StoredValueGuard>
      }
    />
    <Route
      path={routeCreator.updateByOffer(':offerId')}
      element={
        <StoredValueGuard fallback={fallback}>
          <StoredValueUpdateByOfferPage />
        </StoredValueGuard>
      }
    />
    <Route
      path={`${routeCreator.base}/update/:storedValueProgramId/*`}
      element={
        <StoredValueGuard fallback={fallback}>
          <StoredValueUpdatePage />
        </StoredValueGuard>
      }
    />
    <Route
      path={`${routeCreator.details}`}
      element={
        <StoredValueGuard fallback={fallback}>
          <StoredValueDetailsPage />
        </StoredValueGuard>
      }
    />
    <Route
      path={`${routeCreator.list}`}
      element={
        <StoredValueGuard fallback={fallback}>
          <StoredValueListPage />
        </StoredValueGuard>
      }
    />
  </>
);
